var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmailMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 35,
    cy: 35,
    r: 35,
    fill: "url(#paint0_linear_261_6891)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 35,
    cy: 35,
    r: 30,
    fill: "url(#paint1_linear_261_6891)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6723 48.3166H25.3275V34.5826L17.2487 28.5234V45.8929C17.2487 47.232 18.3332 48.3166 19.6723 48.3166Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7161 48.3166H50.3712C51.7103 48.3166 52.7949 47.232 52.7949 45.8929V28.5234L44.7161 34.5826V48.3166Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7161 24.0806V34.583L52.7949 28.5239V25.2924C52.7949 22.2972 49.3755 20.5865 46.9781 22.384L44.7161 24.0806Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3281 34.5826V24.0801L35.0227 31.351L44.7173 24.0801V34.5826L35.0227 41.8535L25.3281 34.5826Z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2487 25.2924V28.5239L25.3275 34.583V24.0806L23.0654 22.384C20.668 20.5865 17.2487 22.2972 17.2487 25.2924Z",
    fill: "#C5221F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_6891",
    x1: -1151.5,
    y1: 2375.8,
    x2: 3885.7,
    y2: 2375.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8100BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_6891",
    x1: -982,
    y1: 2041.4,
    x2: 3335.6,
    y2: 2041.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8100BE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailMessage);
export default __webpack_public_path__ + "static/media/GmailMessage.ed2176dc.svg";
export { ForwardRef as ReactComponent };